export let timeRange = "ec4Mw";
export let timeRangeDifferentDay = "rZIsLc";
export let timeRangeTimeZoneTransition = "OH83ve";
export let timeRangeDifferentDayTimeZoneTransition = "VlF4ke";
export default {timeRange,timeRangeDifferentDay,timeRangeTimeZoneTransition,timeRangeDifferentDayTimeZoneTransition};